// Generated by purs version 0.11.7
"use strict";
var Data_Newtype = require("../Data.Newtype");
var Data_Profunctor = require("../Data.Profunctor");
var Data_Profunctor_Closed = require("../Data.Profunctor.Closed");
var Zipping = function (x) {
    return x;
};
var profunctorZipping = new Data_Profunctor.Profunctor(function (f) {
    return function (g) {
        return function (v) {
            return function (a1) {
                return function (a2) {
                    return g(v(f(a1))(f(a2)));
                };
            };
        };
    };
});
var newtypeZipping = new Data_Newtype.Newtype(function (n) {
    return n;
}, Zipping);
var closedZipping = new Data_Profunctor_Closed.Closed(function () {
    return profunctorZipping;
}, function (v) {
    return function (f1) {
        return function (f2) {
            return function (x) {
                return v(f1(x))(f2(x));
            };
        };
    };
});
module.exports = {
    Zipping: Zipping,
    newtypeZipping: newtypeZipping,
    profunctorZipping: profunctorZipping,
    closedZipping: closedZipping
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Lens.Internal.Zipping/index.js
// module id = 558
// module chunks = 0